import { and, bool, not, or, reads } from '@ember/object/computed';
import { isMobileApp } from 'client-portal/utils/mobile-detect';
import { service } from '@ember/service';
import Route from '@ember/routing/route';
import SiteRedirectsMixin from 'client-portal/mixins/route/site-redirects';
import classic from 'ember-classic-decorator';

@classic
export default class SiteRoute extends Route.extend(SiteRedirectsMixin) {
  @service router;
  @service session;
  @service currentPractice;
  @service prospectiveClient;
  @service billingTransfer;

  queryParams = {
    isHeaderFooterHidden: {},
  };

  @reads('currentPractice.featureClientPortalLegalAgreements') featureClientPortalLegalAgreements;
  @bool('session.currentClientAccess') hasClientAccess;
  @not('session.currentClientAccess.isOtpPending') notOtpPending;
  @not('session.currentClientAccess.eulaAgreementAccepted') hasNotAcceptedEula;
  @not('session.currentClientAccess.termsOfServiceAgreementAccepted') hasNotAcceptedTerms;
  @not('session.currentClientAccess.privacyPolicyAgreementAccepted') hasNotAcceptedPrivacy;
  @not('session.data.skipLicenseAgreement') canShowLicenseAgreement;
  @not('session.data.skipLegalAgreements') canShowLegalAgreements;
  @or('hasNotAcceptedEula', 'hasNotAcceptedTerms', 'hasNotAcceptedPrivacy')
  hasNotAcceptedLegalAgreements;
  @and('notOtpPending', 'hasClientAccess', 'canShowLicenseAgreement', 'hasNotAcceptedEula')
  showLicenseAgreement;
  @and(
    'notOtpPending',
    'hasClientAccess',
    'canShowLegalAgreements',
    'hasNotAcceptedLegalAgreements',
    'featureClientPortalLegalAgreements'
  )
  showLegalAgreements;

  async beforeModel(transition) {
    let { isHeaderFooterHidden, redirect } = transition.to.queryParams;
    let inAppOrRedirectToViewDocuments =
      isMobileApp() || isHeaderFooterHidden || redirect?.includes('documents');

    if (
      (this.showLegalAgreements || this.showLicenseAgreement) &&
      !inAppOrRedirectToViewDocuments
    ) {
      this.featureClientPortalLegalAgreements
        ? this.router.transitionTo('site.legal-agreements')
        : this.router.transitionTo('site.license-agreement');
    }

    // Must land before the mixin's client-selection bounce so a transfer deep link
    // never detours through the client picker on a billing delegated session. Gated on
    // the sync check so an unswitchable target still bounces without an async yield.
    if (this.billingTransfer.canSwitchForTransferDeepLink(transition)) {
      await this.billingTransfer.switchIfTransferClientMismatch(transition);
    }

    this.billingTransfer.resetBillingTransferSession(transition);

    super.beforeModel(...arguments);
  }

  setupController(controller) {
    super.setupController(...arguments);

    controller.setProperties({
      showingAgreements: this.showLicenseAgreement || this.showLegalAgreements,
      hideFooterOnEula: this.showLicenseAgreement && !this.featureClientPortalLegalAgreements,
    });
  }
}
